import { useI18n } from 'vue-i18n';
import * as yup from 'yup';

export default () => {
  const { t } = useI18n();
  const numberTransform = (value: any) => (isNaN(value) ? undefined : value);

  const stationTimeslotSchema = yup.object().shape({
    id: yup.string().nullable().optional(),
    timeslots: yup.object().shape({
      delivery_is_user_defined: yup.boolean().required(t('errorMessages.required')),
      delivery_time: yup.number().when('delivery_is_user_defined', {
        is: true,
        then: yup.number().nullable(),
        otherwise: yup
          .number()
          .transform(numberTransform)
          .min(1, t('errorMessages.genericRequired'))
          .required(t(`errorMessages.genericRequired`)),
      }),
      delivery_prep_time: yup
        .number()
        .transform(numberTransform)
        .min(1, t('errorMessages.genericRequired'))
        .required(t(`errorMessages.genericRequired`)),
      delivery_customers_per_slot: yup
        .number()
        .transform(numberTransform)
        .min(1, t('errorMessages.genericRequired'))
        .required(t(`errorMessages.genericRequired`)),
      delivery_destinations: yup.array().when('delivery_is_user_defined', {
        is: false,
        then: yup.array().min(1).required(t('errorMessages.required')),
        otherwise: yup.array().nullable(),
      }),
      delivery_user_defined: yup
        .array()
        .when('delivery_is_user_defined', {
          is: true,
          then: yup.array().min(1).required(t('errorMessages.required')),
          otherwise: yup.array().min(0),
        })
        .of(
          yup.object().shape({
            start_time: yup.string(),
            end_time: yup.string(),
            delivery_destinations: yup.array(),
          }),
        ),
    }),
    is: yup.object().shape({
      delivery_supported: yup.boolean().required(t('errorMessages.required')),
    }),
  });

  return {
    stationTimeslotSchema,
  };
};
